import { HomePanel } from '~/components/home/home-panel.tsx';
import {
  mapVenueOptions,
  resolveSelectedVenueId,
  resolveSelectedVenueName,
} from '~/components/home/resolve-selected-venue.ts';
import type { HomeReservation } from '~/routes/_index/fetch-home-reservations.server.ts';
import type { HomeMetadataQuery } from '~/utils/graphql/gql.server.ts';

type HomeVenue = NonNullable<NonNullable<HomeMetadataQuery['me']>['venueGroup']>['venues'][number];

type AuthenticatedHomeProps = {
  venues: HomeVenue[];
  venueGroupName: string | null;
  preferredVenueIds: string[];
  reservations: HomeReservation[];
  reservationsHasMore: boolean;
  locale?: string | null;
  timezone?: string | null;
};

const AuthenticatedHome = ({
  venues,
  venueGroupName,
  preferredVenueIds,
  reservations,
  reservationsHasMore,
  locale,
  timezone,
}: AuthenticatedHomeProps) => {
  const venueOptions = mapVenueOptions(venues);
  const selectedVenueId = resolveSelectedVenueId({
    venues: venueOptions,
    preferredVenueIds,
  });
  const selectedVenueName = resolveSelectedVenueName({
    venues: venueOptions,
    preferredVenueIds,
    venueGroupName,
  });

  return (
    <HomePanel
      venues={venueOptions}
      selectedVenueId={selectedVenueId}
      selectedVenueName={selectedVenueName}
      reservations={reservations}
      reservationsHasMore={reservationsHasMore}
      locale={locale}
      timezone={timezone}
    />
  );
};

export default AuthenticatedHome;
